import { z } from "zod";

export const BoardNotesSchema = z.object({
  id: z.int().positive().readonly(),
  board: z.int(),
  content: z.string().readonly(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  archived: z.boolean(),
  created_at: z.iso.datetime().readonly(),
  updated_at: z.iso.datetime().readonly(),
  task: z.int().nullable(),
  client: z.int().nullable(),
  resource: z.int().nullable(),
  order: z.number().min(0).max(2147483647),
  can_edit_grant: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6)
  ]),
  can_view_grant: z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6)
  ]),
  creator: z.int().nullable(),
  updater: z.int().nullable()
});
